export default __webpack_public_path__ + "images/models/1b89f6e69159a814ba01326ca241bb59.usdz";